const SITE_SCOPED_KNOWLEDGE_SOURCES = new Set(['confluence', 'jira', 'jsm']);

export const isSiteScopedKnowledgeSource = (source: string): boolean =>
	SITE_SCOPED_KNOWLEDGE_SOURCES.has(source);
